<template>
    <div class="inventorySection">
        <div class="addNewMeh">
            <div style="display:flex; gap:10px; align-items:center; margin:10px 0;">
                <button
                    class="btnBackfill"
                    @click="backfillImageFieldForAllProducts"
                    :disabled="isBackfilling"
                >
                    {{ isBackfilling ? 'מעדכן...' : 'הוסף שדה תמונה לכל המוצרים' }}
                </button>
<button @click="fixOrderedTimesForAllProducts" :disabled="isFixing">
  {{ isFixing ? 'جاري التحديث...' : 'تحديث orderedTimes لكل المنتجات' }}
</button>
                <small v-if="backfillReport" style="color:#6c757d;">
                    {{ backfillReport }}
                </small>
            </div>

            <span>{{ this.succsessMsg }}</span>
                <div class="mehTitle">
                    <h1>הוספת מוצר ומחירון</h1>
                </div>
                <div class="mehForm">
                    <div class="mehInputField">
                        <input type="text" placeholder="שם המוצר" v-model="item.Name">
                    </div>
                    <div class="mehInputField">
                        <input type="number" placeholder="מחירון ₪" v-model.number="item.Price" >
                    </div>
                    
                    <div class="mehInputField">
                        <select v-model="item.category">
                            <option value="" selected>בחר קטגוריה</option>
                            <option value="עוגות מרובעות">עוגות מרובעות</option>
                            <option value="עוגות עגולות">עוגות עגולות</option>
                            <option value="פסים">פסים</option>
                            <option value="שמרים">שמרים</option>
                            <option value="קופסאות">קופסאות</option>
                            <option value="מגשים">מגשים </option>
                            <option value="חד פעמי">חד פעמי</option>
                            <option value="שתיה">שתיה</option>
                            <option value="חטיפים">חטיפים</option>
                            <option value="עוגות להזנמות">עוגות להזנמות</option>
                        </select>
                    </div>
                    
                    <div class="mehInputField">
                        <input type="submit" @click="sendProduct()" >
                    </div>

                    <!-- <button @click="addfield">הוספת מערך</button> -->
                </div>
            </div>
            <div class="categoriesList">
                <div class="categoryItem"  @click="loadBigCakes()" >עוגות מרובעות</div>
                <div class="categoryItem"  @click="loadCircleCakes()" >עוגות עגולות</div>
                <div class="categoryItem"  @click="loadPasim()" >פסים</div>
                <div class="categoryItem"  @click="loadShmareem()" >שמרים</div>
                <div class="categoryItem"  @click="loadKofsaot()" >קופסאות</div>
                <div class="categoryItem"  @click="loadOneUse()" >חד פעמי</div>
                <div class="categoryItem"  @click="loadMagashim()" >מגשים</div>
                <div class="categoryItem"  @click="loadshtea()" >שתיה</div>
                <div class="categoryItem"  @click="loadHatifim()" >חטיפים</div>
                <div class="categoryItem"  @click="loadSpecialCakes()" >עוגות להזנמות</div>

            </div>
            <!-- <b style="display: block;">{{ selectedCategory }}</b> -->
            <div class="searchInput">
                <input type="text" placeholder="חיפוש" v-model="txtSearch">
            </div>



            <div class="productsList">
                <div class="productsCategories">
                    <span>שם המוצר</span>
                    <span>קטגוריה</span>
                    <span>כמות במלאי</span>
                    <span>מחיר</span>
                    <span>כלים</span>
                </div>
                <div class="productLine" v-for="(item, index) in filteredProducts" :key="index">
                    <span class="" v-if="showIndex !== index">{{item.Data.Name}}</span>
                    <span class="" v-if="showIndex === index" ><input type="text" v-model="item.Data.Name"></span>
                    
                    <span class="">{{item.Data.category}}</span>
                    <span class="inputsBox">
                        <input type="button" value="-" @click="reduceProduct(item)" class="minus" >
                        <input type="text" v-model="item.Data.Quantity" class="stock" @change="updateProduct(item)" >
                        <input type="button" value="+"  @click="increaseProduct(item)" class="plus" > 
                    </span>
                    <span class="quantity"  v-if="showIndex !== index">{{ item.Data.Price }} ש"ח </span>
                    <span class="" v-if="showIndex === index" ><input type="number" v-model.number="item.Data.Price"></span>
                    <span>

                        <button @click="deleteItem(item, index)" > x מחק </button>
                    <button @click="editProductData(index)" > <i class="material-icons">edit</i> עריכה </button>
                    <button @click="editProduct(item, index)" v-if="showIndex === index" > <i class="material-icons">done</i> שמור </button>
                    </span>
                </div>
            </div>



        <!-- 
        <div class="boxesContainer">
            <div class="productBox" v-for="(item, index) in filteredProducts" :key="index">
                <button @click="deleteItem(item)" class="deleteBTN"> X </button>
                <span class="name">{{item.Data.Name}}</span>
                <span class="quantity">{{ item.Data.Price }} ש"ח </span>
                <div class="inputsBox">
                    <input type="button" value="-" @click="reduceProduct(item)" class="minus" >
                    <input type="text" v-model="item.Data.Quantity" class="stock"  >
                    <input type="button" value="+"  @click="increaseProduct(item)" class="plus" >  
                </div>
            </div> 
        </div>
        -->

    </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import { db } from "../firebase";
import moment from 'moment';

export default{
  name: 'Inventory',
  data () {
    return {
            Products:[],
            item:{
                Name:'',
                Quantity:0,
                Price: '' ,
                category: '',
            },
            totalProducts:'',
            editEnabled: false,
            EditItem:null,
            selectedCategory:null,
            succsessMsg:'',
            txtSearch:'',
            showIndex: null,
            isBackfilling: false,
            backfillReport: "",
            isFixing: false

        
        
    }
  },created(){
    let vm = this;
    vm.loadProducts();
    
    },
    computed: {
      filteredProducts() {
        let vm = this;
        if (vm.txtSearch.length > 0) {
          let Products = [];
          for (let i = 0; i < vm.Products.length; i++) {
            let t = vm.Products[i];
            let found = false;
            if (t.Data.Name.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
              found = true;
            }
            if (found) {
                Products.push(t);
            }
          }
          return Products;
        } else {
          return vm.Products;
        }
      }
    },

    methods:{
      async fixOrderedTimesForAllProducts() {
  const db = firebase.firestore()
  this.isFixing = true

  try {
    const snapshot = await db.collection("Products").get()

    let batch = db.batch()
    let operations = 0
    let totalUpdated = 0

for (const doc of snapshot.docs) {
  const data = doc.data() // 🔥 هذا السطر كان ناقص

  if (data.orderedTimes === undefined) {
    batch.update(doc.ref, {
      orderedTimes: 0
    })

    operations++
    totalUpdated++
  }

  if (operations === 400) {
    await batch.commit()
    batch = db.batch()
    operations = 0
  }
}

    // آخر دفعة
    if (operations > 0) {
      await batch.commit()
    }

    alert(`✅ تم تحديث ${totalUpdated} منتج`)
  } catch (error) {
    console.error(error)
    alert("❌ صار خطأ")
  } finally {
    this.isFixing = false
  }
},
        async backfillImageFieldForAllProducts() {
  let vm = this;

  const answer = confirm("سيتم إضافة שדה imageUrl לכל المنتجات اللي ناقصها. متأكد؟");
  if (!answer) return;

  vm.isBackfilling = true;
  vm.backfillReport = "";

  const COLLECTION = "Products";
  const FIELD_NAME = "imageUrl";
  const DEFAULT_VALUE = "https://png.pngtree.com/png-vector/20221125/ourmid/pngtree-no-image-available-icon-flatvector-illustration-pic-design-profile-vector-png-image_40966566.jpg"; // حط رابط placeholder إذا بدك
  const PAGE_SIZE = 450; // أقل من 500 للراحة

  try {
    let lastDoc = null;
    let totalUpdated = 0;
    let totalSkipped = 0;
    let totalScanned = 0;

    while (true) {
      let query = db
        .collection(COLLECTION)
        .orderBy(firebase.firestore.FieldPath.documentId())
        .limit(PAGE_SIZE);

      if (lastDoc) query = query.startAfter(lastDoc);

      const snap = await query.get();
      if (snap.empty) break;

      let batch = db.batch();
      let ops = 0;

      snap.docs.forEach((doc) => {
        totalScanned++;
        const data = doc.data() || {};
        const hasField = Object.prototype.hasOwnProperty.call(data, FIELD_NAME);

        if (hasField) {
          totalSkipped++;
          return;
        }

        batch.update(doc.ref, {
          [FIELD_NAME]: DEFAULT_VALUE,
          // اختياري جداً:
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        });

        totalUpdated++;
        ops++;
      });

      if (ops > 0) await batch.commit();

      lastDoc = snap.docs[snap.docs.length - 1];

      // تحديث report للمستخدم
      vm.backfillReport = `Checked: ${totalScanned} | Updated: ${totalUpdated} | Skipped: ${totalSkipped}`;

      if (snap.size < PAGE_SIZE) break;
    }

    alert(`✅ تم!
تم فحص: ${totalScanned}
تم تحديث: ${totalUpdated}
تم تخطي: ${totalSkipped}`);

    // إذا بدك تعيد تحميل المنتجات بعد التحديث:
    vm.loadProducts();
  } catch (e) {
    console.error(e);
    alert("❌ خطأ: " + (e.message || e));
  } finally {
    vm.isBackfilling = false;
  }
},
        deleteItem(item){
          let vm = this;
          console.log("Product Id is : ", item.ID)
          let answer = confirm("האם אתה בטוח למחוק המוצר?" );
          
          if (answer){
            db.collection("Products").doc(item.ID).delete().then(() => {
                console.log("Document successfully deleted!");
                vm.loadProducts();
                
            }).catch((error) => {
                console.error("Error removing document: ", error);
            });

          }
        },
        // addToArray(){
        //     this.testsArray.push(this.test);
        //     console.log(this.testsArray);
        // },
        // addfield(){
        //     let vm = this;
            
        //     db.collection("Products").get().then((querySnapshot) => {
        //     querySnapshot.forEach((doc) => {
        //         doc.ref.update({orderedTimes: 0})
        //     })
        //     console.log("Success")
        //     })
        // },
        loadProducts(){
            let vm = this;
            vm.Products = [];
            if(vm.selectedCategory == null){
                db.collection("Products").get().then((result)=>{
                for(let a = 0; a < result.size; a++){
                      let itemId = result.docs[a].id;
                      let item = result.docs[a].data();
                      // console.log(orderResult.size);
                      vm.Products.push({
                        ID : itemId,
                        Data : item
                        
                        });
              }
              vm.totalProducts = result.size;

            }).catch((error)=>{
                console.log("Error Loading Products", error)
            })
            }
            else{
                db.collection("Products").where("category", "==", vm.selectedCategory).get().then((result)=>{
                for(let a = 0; a < result.size; a++){
                      let itemId = result.docs[a].id;
                      let item = result.docs[a].data();
                      // console.log(orderResult.size);
                      vm.Products.push({
                        ID : itemId,
                        Data : item
                        
                        });
              }
              vm.totalProducts = result.size;

            }).catch((error)=>{
                console.log("Error Loading Products", error)
            })
            }
            
            
        },
        loadBigCakes(){
            let vm = this;
            vm.selectedCategory = 'עוגות מרובעות';
            vm.loadProducts();
        },
        loadCircleCakes(){
            let vm = this;
            vm.selectedCategory = 'עוגות עגולות';
            vm.loadProducts();
        },
        loadPasim(){
            let vm = this;
            vm.selectedCategory = 'פסים ושמרים';
            vm.loadProducts();
        },
        loadHatifim(){
            let vm = this;
            vm.selectedCategory = 'חטיפים';
            vm.loadProducts();
        },
        loadshtea(){
            let vm = this;
            vm.selectedCategory = 'שתיה';
            vm.loadProducts();
        },
        loadSpecialCakes(){
            let vm = this;
            vm.selectedCategory = 'עוגות להזנמות';
            vm.loadProducts();
        },
        loadShmareem(){
            let vm = this;
            vm.selectedCategory = 'שמרים';
            vm.loadProducts();
        },
        loadMagashim(){
            let vm = this;
            vm.selectedCategory = 'מגשים';
            vm.loadProducts();
        },
        loadOneUse(){
            let vm = this;
            vm.selectedCategory = 'חד פעמי';
            vm.loadProducts();
        },
        loadKofsaot(){
            let vm = this;
            vm.selectedCategory = 'קופסאות';
            vm.loadProducts();
        },
        sendProduct(){
            let vm = this;
            vm.Products = [];
            db.collection("Products").add(vm.item).then((result)=>{
              console.log("Product has been added", result);
              vm.item ={ 
                Name:'',
                Quantity:0,
                Price: '' ,
                category: '',
                imageUrl : '' 

            }
              vm.loadProducts();
                vm.succsessMsg = "המוצר נוסף בהצלחה"
            }).catch((error)=>{
                console.log("Error adding Products", error)
            })
        },
        updateProduct(item){
            let vm = this;
            let newQuantity = item.Data.Quantity;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                // alert("הכמות במלאי עודכנה בהצלחה");
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        },
        editProductData(index){
            let vm = this;
            vm.showIndex = index;
            console.log("Edit Enabled");

            if (!vm.editEnabled) {
                vm.editEnabled = true;
                vm.showIndex = index;
            } else {
                vm.editEnabled = false;
                vm.showIndex = null;
            }
            
        },
        editProduct(item){
            let vm = this;
            let newProductName = item.Data.Name;
            let newProductPrice = item.Data.Price;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Name = newProductName;
                orderData.Price = newProductPrice;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("Data successfully updated ") ;
                vm.editEnabled = false;
                vm.showIndex = null;
                // alert("הכמות במלאי עודכנה בהצלחה");
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        },
        reduceProduct(item){
            item.Data.Quantity--;
            let vm = this;
            let newQuantity = item.Data.Quantity;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        },
        increaseProduct(item){
            item.Data.Quantity++;
            let vm = this;
            let newQuantity = item.Data.Quantity;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        },

    }

}</script>
<style scoped>
.inventorySection{
    width: 100%;
    height: 100%;
    padding: 1rem;
}
.categoriesList{
    width: 100%;
    padding: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow-x: scroll;
}
.categoryItem{
    border: 1px solid #eee;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #fcfcfc;
    margin: 0 0 0 10px;
    padding: 1rem 2rem;
    height: 120px;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
    color: #1c1c1c;
}
.searchInput{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin:  10px 0;
}
.searchInput input {
    width: 40%;
    border: 1px solid #ccc;
    padding: 5px 10px;
    font-size: 14px;
    font-family: 'Noto Sans Hebrew';
}
.productsCategories{
    width: 100%;
    padding: 10px;
    border: 0;
    background-color: #f9fafc;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    justify-content: space-between;
    color: #6c757d;
}
.productsCategories span,
.productLine span
{
    font-size: 14px;
    font-weight: 400;
    font-family: 'Noto Sans Hebrew';
    width: calc(100% / 5 - 5px);
}
.productLine span{
    color: #3c4c5d;
    font-weight: 500;
}
.productLine{
    padding: 10px;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.productLine:nth-child(even){
    background-color: #fcfcfc;
}
.productLine button {
    border: 0;
    font-size: 13px;
    color: #6c757d;
    background-color: transparent;
    margin:  0 5px;
}
.productLine button i{
    font-size: 14px;
}

/* ---------------- */
.productLine .inputsBox {
    display: flex;
    align-items: center;
    border-radius: 50%;
}
.productLine .inputsBox .stock{
    width: 50px;
    height: 30px;
    border: 0px solid #e0e0e0;
    background-color: #fcfcfc;
    font-size: 15px;
    color: #000;
    text-align: center;
    margin: 0 5px;
    border-radius: 20%;
}
.productLine .inputsBox .minus,
.productLine .inputsBox .plus{
    width: 30px;
    height: 30px;
    border: 1px solid #e0e0e0;
    background-color: #fff;
    font-size: 20px;
    color: #000;
    border-radius: 20%;
}
.addNewMeh{
    width: 100%;
    background-color: #fcfcfc;
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 1rem;
}
.addNewMeh .mehTitle h1{
    font-size: 20px;
    color: var(--grey);
    font-family: 'Noto Sans Hebrew';
    font-weight: 700;
}
.mehForm{
    width: 100%;
    background-color: transparent;
    margin: 1rem 0rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
}
.mehInputField{
    display: inline-block;
    width: calc(100% / 4 - 5px);
    vertical-align: middle;
}
.mehInputField input,
.mehInputField select{
    width: 100%;
    height: 37px;
    padding: 0 10px;
    font-size: 14px;
    border: 1px solid #eee;
    outline: none;
    transition: 0.3s;
}

.mehInputField input[type=submit]{
    width: 100%;
    height: 37px;
    font-size: 14px;
    outline: none;
    transition: 0.3s;
    background-color: #baf3e6;
    color: #004d5a;
    padding-right: 0px;
    border: 0;
    font-weight: 700;
}
.deleteBTN{
    position: absolute;
    top: 0;
    left: 0;
    padding: 2px 10px;
    background-color: #d11a2a;
    color: #fff;
    font-size: 14px;
    border-top-left-radius: 8px;
    border: 0;
    border-bottom-right-radius: 8px;
}
@media screen and (max-width:500px){
    .productBox {
        width: calc(100% / 2 - 5px);
        border: 1px solid #e0e0e0;
    }
    .mehInputField {
        width: calc(100% / 2 - 3px);
        margin: 2px 0;
    }
    .mehForm{
        flex-wrap: wrap;
    }
    .productBox .name{
    font-size: 15px;
}

.btnBackfill{
  border:0;
  padding:10px 14px;
  border-radius:8px;
  background:#004d5a;
  color:#fff;
  font-weight:700;
  cursor:pointer;
}
.btnBackfill:disabled{
  opacity:0.6;
  cursor:not-allowed;
}

}
</style>


// WEBPACK FOOTER //
// src/pages/Inventory.vue